import { IGetByIdEquipamentoMedicaoUseCase } from "../../../presentation/useCases/read/get_by_id_equipamento_medicao_use_case";
import { EquipamentoMedicao } from "../../models/EquipamentoMedicao";
import { IEquipamentoMedicaoRepository } from "../../repositories/EquipamentoMedicao_Repositorie";

/**
 * GetByIdEquipamentoMedicaoUseCase
 */

export class GetByIdEquipamentoMedicaoUseCase implements IGetByIdEquipamentoMedicaoUseCase {
  constructor(private readonly repository: IEquipamentoMedicaoRepository) { }

  async getByIdEquipamentoMedicao(idEquipamentoMedicao: number): Promise<EquipamentoMedicao> {
    const response = await this.repository.getEquipamentoMedicaoById(idEquipamentoMedicao);
    return response;
  }
}
